import Enum from '../interfaces/IEnum';

export const Constants: Enum = {
    name: {
        CONVOCA: 'Convoca'
    },
    savia: {
        googleAnalyticsOptInBrowserAddOn: 'https://tools.google.com/dlpage/gaoptout?hl=de%3Cbr/',
        sedeAGPD: 'https://sedeagpd.gob.es/sede-electronica-web/',
        dpoEmail: 'dpo@savia.net',
        urlSavia: 'https://www.savia.net/',
        phone: '913142815',
        apiKey: 'AIzaSyB6KR9J_PxVodaCee6Wl7UVRy-VpY54gg8'
    },
    country: {
        SPAIN_CODE: 724
    },
    fileImporter: {
        VALID_EXTENSIONS: ['.bmp', '.jpg', '.jpeg', '.pdf', '.png'],
        INVALID_FILE_NAME: ['"', '<', '>', '|', ':', '*', '?', '/', '\\'],
        PDF: '.pdf',
        CSV: '.csv',
        MAX_SIZE: 10 * 1024 * 1024 // 10MB on binary sense
    },
    inscription: {
        MAX_YEARS: 99.999,
        MAX_FULL_YEARS: 99
    },
    language: {
        ES_ES: 'es-ES',
        CA_ES: 'ca-ES',        
        EU_ES: 'eu-ES',
        GL_ES: 'gl-ES',
        VL_ES: 'pt-PT',
        EN_US: 'en-US',
        primary: 0,
        secondary: 1
    },
    translation: {
        'es-ES': 'es',
        'ca-ES': 'ca',        
        'eu-ES': 'eu',
        'gl-ES': 'gl',
        'pt-PT': 'ca',
        'en-US': 'en'
    },
    sharedLengths: {
        TWENTY: 20,
        FOURTY: 40,
        ONE_THOUSAND: 1000,
        THREE_THOUSAND: 3000,
        THREE_HUNDRED: 300
    },
    process: {
        ZERO: 0,
        YEAR_INITIAL: 2017,
        YEAR_INITIAL_CONVOCA: 2018,
        PROCESS_TYPES: [0, 1, 2]
    },
    routeActive: {
        DASHBOARD: '/dashboard',
        CALLS: '/calls/',
        BAGS: '/bags/',
        POST_PROVISION: '/postProvisions/',
        BOEP: '/BOEP/',
        LIST_MANAGEMENT: '/listManagement/',
        RATINGS: '/ratings/',
        REPLACEMENT: '/replacement/',
        PROCESS: '/process/',
        CANDIDATES: '/candidates/'
    },
    minimumInscriptionCandidateAge: 16,
    maximumInscriptionCandidateAge: 70,
    dateHourFormat: 'HH:mm'
};
